import { createRouter, createWebHistory } from 'vue-router'
import Layout from '@/layout'

// 设置页面元数据
const setPageMeta = (to) => {
  const lang = to.query.lang || 'en';
  console.log('[元数据更新] 当前语言:', lang);

  // 确保DOM已加载
  const updateMeta = () => {
    try {
      if (lang === 'en') {
        document.title = '123Plat - Custom AI Tool Navigation Platform | Large Model Aggregation Platform';
        const desc = document.querySelector('meta[name="description"]');
        const keywords = document.querySelector('meta[name="keywords"]');
        if (desc) desc.setAttribute('content',
          '123Plat (123plat.cloud) is a simple AI tool navigation website that supports custom layouts. It aggregates Chinese large models (such as Wenxin, ERNIE3.0, GLM-3-5XXL, etc.), supports multi-scenario tool classification, and updates the latest AI tools and technologies to help users easily use high-quality AI tools and improve creative efficiency.');
        if (keywords) keywords.setAttribute('content',
          'AI navigation, 123Plat, custom navigation platform, large model aggregation, GPT4, Chinese models, multilingual models, text generation');
        console.log('[元数据更新] 已设置为英文');
      } else if(lang === 'zh') {
        document.title = '123Plat - 可自定义 AI 工具导航平台 | 聚合 GPT-4/Gemini/Claude 等大语言模型与 AI 生成工具的简洁导航网站';
        const desc = document.querySelector('meta[name="description"]');
        const keywords = document.querySelector('meta[name="keywords"]');
        if (desc) desc.setAttribute('content',
          '123Plat（123plat.cloud）是一款可自定义的简洁导航网站，专注于聚合全球主流 AI 工具与服务，涵盖 AI 大语言模型（如 GPT-4、Gemini、Claude、Llama3、文心一言、讯飞星火等）、生成式 AI 工具（Stable Diffusion 绘画、Runway 视频生成、Suno AI 音乐创作）、AI 辅助工具（Grammarly 写作优化、DeepL 翻译、代码生成工具）、办公协作平台（Google Workspace、Microsoft 365、Notion）等。用户可根据需求自定义导航布局，快速访问 OpenAI、Hugging Face、MidJourney、Canva 等千余款 AI 工具，是设计师、开发者、内容创作者、企业用户寻找高效 AI 解决方案的一站式导航平台。网站支持多场景工具分类，实时收录最新 AI 技术工具，助力用户轻松获取 AI 资源，提升工作与创作效率。');
        if (keywords) keywords.setAttribute('content',
          'AI 导航网站，123Plat, 自定义导航平台，AI 工具聚合，大语言模型导航，GPT-4,Gemini,Claude,Llama3, 文心一言，讯飞星火，Stable Diffusion,AI 绘画工具，Runway 视频生成，Suno AI 音乐，AI 写作工具，Grammarly,DeepL 翻译，代码生成工具，Google Workspace,Microsoft 365,Notion, 办公协作工具导航，MidJourney,Canva AI,Hugging Face,AI 生成工具目录，全球 AI 工具导航，AI 资源导航，简洁导航网站，设计师 AI 工具，开发者 AI 工具，内容创作 AI 工具，企业 AI 解决方案导航，AI 大模型聚合平台，生成式 AI 导航，AI 辅助工具目录，多语言支持，国际化导航');
        console.log('[元数据更新] 已设置为中文');
      }else if(lang === 'ar') {
        document.title = '123Plat - منصة تنقل أدوات الذكاء الاصطناعي المخصصة | منصة تجميع النماذج الكبيرة';
        const desc = document.querySelector('meta[name="description"]');
        const keywords = document.querySelector('meta[name="keywords"]');
        if (desc) desc.setAttribute('content',
          '123Plat (123plat.cloud) هو موقع تنقل بسيط لأدوات الذكاء الاصطناعي يدعم التخطيطات المخصصة. يجمع نماذج كبيرة صينية (مثل Wenxin، ERNIE3.0، GLM-3-5XXL وما إلى ذلك)، ويدعم تصنيف الأدوات في مختلف السيناريوهات، ويقوم بتحديث أحدث أدوات وتقنيات الذكاء الاصطناعي للمساعدة على استخدام المستخدمين بسهولة أدوات ذكاء اصطناعي عالية الجودة وتحسين كفاءة الإبداع.');
        if (keywords) keywords.setAttribute('content',
          'تنقل الذكاء الاصطناعي، 123Plat، منصة تنقل مخصصة، تجميع النماذج الكبيرة، GPT4، النماذج الصينية، النماذج متعددة اللغات، إنشاء النص');
        console.log('[元数据更新] 已设置为ar');
      }else if(lang === 'bn') {
        document.title = '123Plat - কাস্টমizable এআই টুল নেভিগেশন প্ল্যাটফর্ম | বড় মডেল অ্যাগ্রিগেশন প্ল্যাটফর্ম';
        const desc = document.querySelector('meta[name="description"]');
        const keywords = document.querySelector('meta[name="keywords"]');
        if (desc) desc.setAttribute('content',
          '123Plat (123plat.cloud) একটি সহজ এআই টুল নেভিগেশন ওয়েবসাইট যা কাস্টম লেআউট সমর্থন করে। এটি চীনা বড় মডেলগুলি (যেমন Wenxin, ERNIE3.0, GLM - 3 - 5XXL ইত্যাদি) একত্রিত করে, মাল্টি - সিনারিও টুল বিভাগ সমর্থন করে এবং সর্বশেষ এআই টুল এবং প্রযুক্তি আপডেট করে যাতে ব্যবহারকারীরা সহজেই উচ্চমানের এআই টুল ব্যবহার করতে পারে এবং সৃজনশীলতার দক্ষতা বাড়াতে পারে।');
        if (keywords) keywords.setAttribute('content',
          'এআই নেভিগেশন, 123Plat, কাস্টম নেভিগেশন প্ল্যাটফর্ম, বড় মডেল অ্যাগ্রিগেশন, GPT4, চীনা মডেল, বহুভাষিক মডেল, টেক্সট জেনারেশন');
        console.log('[元数据更新] 已设置为bn');
      }else if(lang === 'de') {
        document.title = '123Plat - Anpassbare Navigationsplattform für KI - Tools | Plattform zur Aggregation großer Modelle';
        const desc = document.querySelector('meta[name="description"]');
        const keywords = document.querySelector('meta[name="keywords"]');
        if (desc) desc.setAttribute('content',
          '123Plat (123plat.cloud) ist eine einfache Navigationswebsite für KI - Tools, die benutzerdefinierte Layouts unterstützt. Sie aggregiert chinesische große Modelle (wie Wenxin, ERNIE3.0, GLM - 3 - 5XXL usw.), unterstützt die Klassifizierung von Tools für verschiedene Szenarien und aktualisiert die neuesten KI - Tools und - Technologien, um Benutzern zu helfen, qualitativ hochwertige KI - Tools einfach zu nutzen und die kreative Effizienz zu verbessern.');
        if (keywords) keywords.setAttribute('content',
          'KI - Navigation, 123Plat, benutzerdefinierte Navigationsplattform, Aggregation großer Modelle, GPT4, chinesische Modelle, mehrsprachige Modelle, Textgenerierung');
        console.log('[元数据更新] 已设置为de');
      }else if(lang === 'es') {
        document.title = '123Plat - Plataforma de navegación de herramientas de IA personalizable | Plataforma de agregación de modelos grandes';
        const desc = document.querySelector('meta[name="description"]');
        const keywords = document.querySelector('meta[name="keywords"]');
        if (desc) desc.setAttribute('content',
          '123Plat (123plat.cloud) es un sitio web de navegación de herramientas de IA simple que admite diseños personalizados. Agrega modelos grandes chinos (como Wenxin, ERNIE3.0, GLM - 3 - 5XXL, etc.), admite la clasificación de herramientas para múltiples escenarios y actualiza las últimas herramientas y tecnologías de IA para ayudar a los usuarios a utilizar fácilmente herramientas de IA de alta calidad y mejorar la eficiencia creativa.');
        if (keywords) keywords.setAttribute('content',
          'Navegación de IA, 123Plat, plataforma de navegación personalizable, agregación de modelos grandes, GPT4, modelos chinos, modelos multilingües, generación de texto');
        console.log('[元数据更新] 已设置为es');
      }else if(lang === 'fa') {
        document.title = '123Plat - پلتفرم ناوبری ابزارهای هوش مصنوعی قابل سفارشی سازی | پلتفرم جمع آوری مدل‌های بزرگ';
        const desc = document.querySelector('meta[name="description"]');
        const keywords = document.querySelector('meta[name="keywords"]');
        if (desc) desc.setAttribute('content',
          '123Plat (123plat.cloud) یک وب‌سایت ناوبری ساده برای ابزارهای هوش مصنوعی است که از چیدمان‌های سفارشی پشتیبانی می‌کند. این وب‌سایت مدل‌های بزرگ چینی (مانند Wenxin، ERNIE3.0، GLM - 3 - 5XXL و غیره) را جمع آوری می‌کند، از طبقه‌بندی ابزارها در چندین سناریو پشتیبانی می‌کند و آخرین ابزارها و فناوری‌های هوش مصنوعی را بروزرسانی می‌کند تا به کاربران کمک کند ابزارهای هوش مصنوعی با کیفیت بالا را به راحتی استفاده کنند و راندمان خلاقیت خود را افزایش دهند.');
        if (keywords) keywords.setAttribute('content',
          'ناوبری هوش مصنوعی، 123Plat، پلتفرم ناوبری سفارشی، جمع آوری مدل‌های بزرگ، GPT4، مدل‌های چینی، مدل‌های چندزبانه، تولید متن');
        console.log('[元数据更新] 已设置为fa');
      }else if(lang === 'fr') {
        document.title = '123Plat - Plateforme de navigation outils IA personnalisable | Plateforme agrégation de grands modèles';
        const desc = document.querySelector('meta[name="description"]');
        const keywords = document.querySelector('meta[name="keywords"]');
        if (desc) desc.setAttribute('content',
          '123Plat (123plat.cloud) est un site web de navigation outils IA simple qui prend en charge les mises en page personnalisées. Il agrège de grands modèles chinois (tels que Wenxin, ERNIE3.0, GLM - 3 - 5XXL, etc.), prend en charge la classification des outils pour plusieurs scénarios et met à jour les dernières outils et technologies d\'IA pour aider les utilisateurs à utiliser facilement des outils IA de haute qualité et à améliorer efficacité créative.');
        if (keywords) keywords.setAttribute('content',
          'Navigation IA, 123Plat, plateforme de navigation personnalisable, agrégation de grands modèles, GPT4, modèles chinois, modèles multilingues, génération de texte');
        console.log('[元数据更新] 已设置为fr');
      }else if(lang === 'ha') {
        document.title = '123Plat - Tsarin Kewayon Kayayyakin AI Mai Kyautatawa | Tsarin Haɗin Manyan Samfura';
        const desc = document.querySelector('meta[name="description"]');
        const keywords = document.querySelector('meta[name="keywords"]');
        if (desc) desc.setAttribute('content',
          '123Plat (123plat.cloud) wani ganiyar yanar gizo ne mai sauƙi na kayayyakin AI wanda ke goyan bayan tsarin tsari na musamman. Yana tattara manyan samfuran Sinanci (kamar Wenxin, ERNIE3.0, GLM - 3 - 5XXL, da sauransu), yana goyan bayan rarrabuwar kayayyaki na yanayi da yawa, kuma yana sabunta sabbin kayayyakin AI da fasahohi don taimaka wa masu amfani suyi amfani da kayayyakin AI masu inganci cikin sauƙi da haɓaka ingancin ƙirƙira.');
        if (keywords) keywords.setAttribute('content',
          'Kewayon AI, 123Plat, tsarin kewayon mai kyautatawa, haɗin manyan samfura, GPT4, samfuran Sinanci, samfuran harsuna da yawa, samar da rubutu');
        console.log('[元数据更新] 已设置为ha');
      }else if(lang === 'hi') {
        document.title = '123Plat - कस्टमाइजेबल एआई टूल नेविगेशन प्लेटफॉर्म | लार्ज मॉडल एग्रीगेशन प्लेटफॉर्म';
        const desc = document.querySelector('meta[name="description"]');
        const keywords = document.querySelector('meta[name="keywords"]');
        if (desc) desc.setAttribute('content',
          '123Plat (123plat.cloud) एक साधारण एआई टूल नेविगेशन वेबसाइट है जो कस्टम लेआउट का समर्थन करती है। यह चीनी बड़े मॉडलों (जैसे Wenxin, ERNIE3.0, GLM - 3 - 5XXL आदि) को एकत्रित करती है, मल्टी - सीनारियो टूल वर्गीकरण का समर्थन करती है और नवीनतम एआई टूल और प्रौद्योगिकियों को अपडेट करती है ताकि उपयोगकर्ताओं को आसानी से उच्च - गुणवत्ता वाले एआई टूल का उपयोग करने में मदद मिले और रचनात्मक दक्षता में सुधार हो।');
        if (keywords) keywords.setAttribute('content',
          'एआई नेविगेशन, 123Plat, कस्टम नेविगेशन प्लेटफॉर्म, बड़ा मॉडल एग्रीगेशन, GPT4, चीनी मॉडल, बहुभाषी मॉडल, टेक्स्ट जेनरेशन');
        console.log('[元数据更新] 已设置为hi');
      }else if(lang === 'id') {
        document.title = '123Plat - Platform Navigasi Alat AI yang Dapat Dikustomisasi | Platform Pengumpulan Model Besar';
        const desc = document.querySelector('meta[name="description"]');
        const keywords = document.querySelector('meta[name="keywords"]');
        if (desc) desc.setAttribute('content',
          '123Plat (123plat.cloud) adalah situs web navigasi alat AI sederhana yang mendukung tata letak khusus. Ini mengumpulkan model besar Cina (seperti Wenxin, ERNIE3.0, GLM - 3 - 5XXL, dll.), Mendukung klasifikasi alat untuk berbagai skenario, dan memperbarui alat dan teknologi AI terbaru untuk membantu pengguna dengan mudah menggunakan alat AI berkualitas tinggi dan meningkatkan efisiensi kreativitas.');
        if (keywords) keywords.setAttribute('content',
          'Navigasi AI, 123Plat, platform navigasi khusus, pengumpulan model besar, GPT4, model Cina, model multibahasa, generasi teks');
        console.log('[元数据更新] 已设置为id');
      }else if(lang === 'it') {
        document.title = '123Plat - Piattaforma di navigazione per strumenti AI personalizzabile | Piattaforma di aggregazione di grandi modelli';
        const desc = document.querySelector('meta[name="description"]');
        const keywords = document.querySelector('meta[name="keywords"]');
        if (desc) desc.setAttribute('content',
          '123Plat (123plat.cloud) è un semplice sito web di navigazione per strumenti AI che supporta layout personalizzati. Aggrega grandi modelli cinesi (come Wenxin, ERNIE3.0, GLM - 3 - 5XXL, ecc.), Supporta la classificazione degli strumenti per più scenari e aggiorna gli ultimi strumenti e tecnologie AI per aiutare gli utenti a utilizzare facilmente strumenti AI di alta qualità e migliorare efficienza creativa.');
        if (keywords) keywords.setAttribute('content',
          'Navigazione AI, 123Plat, piattaforma di navigazione personalizzabile, aggregazione di grandi modelli, GPT4, modelli cinesi, modelli multilingue, generazione di testo');
        console.log('[元数据更新] 已设置为it');
      }else if(lang === 'ja') {
        document.title = '123Plat - カスタマイズ可能なAIツールナビゲーションプラットフォーム | 大規模モデル集約プラットフォーム';
        const desc = document.querySelector('meta[name="description"]');
        const keywords = document.querySelector('meta[name="keywords"]');
        if (desc) desc.setAttribute('content',
          '123Plat (123plat.cloud) は、カスタムレイアウトをサポートするシンプルなAIツールナビゲーションウェブサイトです。中国の大規模モデル（文心、ERNIE3.0、GLM - 3 - 5XXLなど）を集約し、多シナリオのツール分類をサポートし、最新のAIツールとテクノロジーを更新して、ユーザーが高品質なAIツールを簡単に使用できるようにし、創造的な効率を向上させます。');
        if (keywords) keywords.setAttribute('content',
          'AIナビゲーション、123Plat、カスタムナビゲーションプラットフォーム、大規模モデル集約、GPT4、中国モデル、多言語モデル、テキスト生成');
        console.log('[元数据更新] 已设置为ja');
      }else if(lang === 'jv') {
        document.title = '123Plat - Platform Navigasi Alat AI sing Bisa Disesuaikan | Platform Agregasi Model Gedhe';
        const desc = document.querySelector('meta[name="description"]');
        const keywords = document.querySelector('meta[name="keywords"]');
        if (desc) desc.setAttribute('content',
          '123Plat (123plat.cloud) minangka situs web navigasi alat AI sing prasaja sing ndhukung tata letak khusus. Iki nglumpukake model gedhe Cina (kayata Wenxin, ERNIE3.0, GLM - 3 - 5XXL, lsp.), Ndhukung klasifikasi alat kanggo macem - macem skenario, lan nganyari alat lan teknologi AI paling anyar kanggo mbantu pangguna kanthi gampang nggunakake alat AI berkualitas dhuwur lan nambah efisiensi kreativitas.');
        if (keywords) keywords.setAttribute('content',
          'Navigasi AI, 123Plat, platform navigasi khusus, agregasi model gedhe, GPT4, model Cina, model multibahasa, generasi teks');
        console.log('[元数据更新] 已设置为jv');
      }else if(lang === 'ko') {
        document.title = '123Plat - 사용자 정의 AI 도구 탐색 플랫폼 | 대형 모델 집계 플랫폼';
        const desc = document.querySelector('meta[name="description"]');
        const keywords = document.querySelector('meta[name="keywords"]');
        if (desc) desc.setAttribute('content',
          '123Plat (123plat.cloud)은 사용자 정의 레이아웃을 지원하는 간단한 AI 도구 탐색 웹사이트입니다. 이 웹사이트는 중국 대형 모델(예: Wenxin, ERNIE3.0, GLM - 3 - 5XXL 등)을 집계하고, 다중 시나리오 도구 분류를 지원하며, 최신 AI 도구 및 기술을 업데이트하여 사용자가 고품질 AI 도구를 쉽게 사용할 수 있도록 돕고 창의적 효율성을 향상시킵니다.');
        if (keywords) keywords.setAttribute('content',
          'AI 탐색, 123Plat, 사용자 정의 탐색 플랫폼, 대형 모델 집계, GPT4, 중국 모델, 다국어 모델, 텍스트 생성');
        console.log('[元数据更新] 已设置为ko');
      }else if(lang === 'mr') {
        document.title = '123Plat - कस्टमाइझेबल AI टूल नेव्हिगेशन प्लॅटफॉर्म | मोठ्या मॉडेल एकत्रीकरण प्लॅटफॉर्म';
        const desc = document.querySelector('meta[name="description"]');
        const keywords = document.querySelector('meta[name="keywords"]');
        if (desc) desc.setAttribute('content',
          '123Plat (123plat.cloud) ही एक सोपी AI टूल नेव्हिगेशन वेबसाइट आहे जी कस्टम लेआउट समर्थन करते. ही चीनी मोठ्या मॉडेल्स (जसे की Wenxin, ERNIE3.0, GLM - 3 - 5XXL इत्यादी) एकत्रित करते, मल्टी - सीनारियो टूल वर्गीकरण समर्थन करते आणि नवीनतम AI टूल्स आणि तंत्रज्ञाने अद्ययावत करते जेणेकरून वापरकर्त्यांना उच्च - गुणवत्तेच्या AI टूल्सचा सहज वापर करू शकेल आणि सर्जनशीलतेची कार्यक्षमता वाढू शकेल.');
        if (keywords) keywords.setAttribute('content',
          'AI नेव्हिगेशन, 123Plat, कस्टम नेव्हिगेशन प्लॅटफॉर्म, मोठा मॉडेल एकत्रीकरण, GPT4, चीनी मॉडेल, बहुभाषिक मॉडेल, मजकूर निर्मिती');
        console.log('[元数据更新] 已设置为mr');
      }else if(lang === 'pa') {
        document.title = '123Plat - ਕਸਟਮਾਈਜੇਬਲ ਏਆਈ ਟੂਲ ਨੈਵੀਗੇਸ਼ਨ ਪਲੇਟਫਾਰਮ | ਵੱਡੇ ਮਾਡਲ ਇਕੱਠੇ ਕਰਨ ਵਾਲਾ ਪਲੇਟਫਾਰਮ';
        const desc = document.querySelector('meta[name="description"]');
        const keywords = document.querySelector('meta[name="keywords"]');
        if (desc) desc.setAttribute('content',
          '123Plat (123plat.cloud) ਇੱਕ ਸਧਾਰਨ ਏਆਈ ਟੂਲ ਨੈਵੀਗੇਸ਼ਨ ਵੈੱਬਸਾਈਟ ਹੈ ਜੋ ਕਸਟਮ ਲੇਆਊਟ ਦਾ ਸਮਰਥਨ ਕਰਦੀ ਹੈ। ਇਹ ਚੀਨੀ ਵੱਡੇ ਮਾਡਲਾਂ (ਜਿਵੇਂ ਕਿ Wenxin, ERNIE3.0, GLM - 3 - 5XXL ਆਦਿ) ਨੂੰ ਇਕੱਠਾ ਕਰਦੀ ਹੈ, ਮਲਟੀ - ਸੀਨੇਰੀਓ ਟੂਲ ਵਰਗੀਕਰਨ ਦਾ ਸਮਰਥਨ ਕਰਦੀ ਹੈ ਅਤੇ ਨਵੀਨਤਮ ਏਆਈ ਟੂਲਾਂ ਅਤੇ ਤਕਨਾਲੋਜੀਆਂ ਨੂੰ ਅਪਡੇਟ ਕਰਦੀ ਹੈ ਤਾਂ ਕਿ ਉਪਭੋਗਤਾਵਾਂ ਨੂੰ ਆਸਾਨੀ ਨਾਲ ਉੱਚ - ਗੁਣਵੱਤਾ ਵਾਲੇ ਏਆਈ ਟੂਲਾਂ ਦੀ ਵਰਤੋਂ ਕਰਨ ਵਿੱਚ ਮਦਦ ਮਿਲੇ ਅਤੇ ਰਚਨਾਤਮਕ ਕੁਸ਼ਲਤਾ ਵਿੱਚ ਸੁਧਾਰ ਹੋਵੇ।');
        if (keywords) keywords.setAttribute('content',
          'ਏਆਈ ਨੈਵੀਗੇਸ਼ਨ, 123Plat, ਕਸਟਮ ਨੈਵੀਗੇਸ਼ਨ ਪਲੇਟਫਾਰਮ, ਵੱਡਾ ਮਾਡਲ ਇਕੱਠੇ ਕਰਨਾ, GPT4, ਚੀਨੀ ਮਾਡਲ, ਬਹੁਭਾਸ਼ਾ ਮਾਡਲ, ਟੈਕਸਟ ਜਨਰੇਸ਼ਨ');
        console.log('[元数据更新] 已设置为pa');
      }else if(lang === 'pt') {
        document.title = '123Plat - Plataforma de navegação de ferramentas de IA personalizável | Plataforma de agregação de grandes modelos';
        const desc = document.querySelector('meta[name="description"]');
        const keywords = document.querySelector('meta[name="keywords"]');
        if (desc) desc.setAttribute('content',
          '123Plat (123plat.cloud) é um site web de navegação de ferramentas de IA simples que suporta layouts personalizados. Ele agrega grandes modelos chineses (como Wenxin, ERNIE3.0, GLM - 3 - 5XXL, etc.), suporta a classificação de ferramentas para vários cenários e atualiza as últimas ferramentas e tecnologias de IA para ajudar os usuários a usar facilmente ferramentas de IA de alta qualidade e melhorar a eficiência criativa.');
        if (keywords) keywords.setAttribute('content',
          'Navegação de IA, 123Plat, plataforma de navegação personalizável, agregação de grandes modelos, GPT4, modelos chineses, modelos multilíngues, geração de texto');
        console.log('[元数据更新] 已设置为pt');
      }else if(lang === 'ru') {
        document.title = '123Plat - Настраиваемая платформа навигации по инструментам ИИ | Платформа агрегации крупных моделей';
        const desc = document.querySelector('meta[name="description"]');
        const keywords = document.querySelector('meta[name="keywords"]');
        if (desc) desc.setAttribute('content',
          '123Plat (123plat.cloud) - это простой веб - сайт навигации по инструментам ИИ, который поддерживает настраиваемые макеты. Он агрегирует крупные китайские модели (такие как Wenxin, ERNIE3.0, GLM - 3 - 5XXL и др.), Поддерживает классификацию инструментов для различных сценариев и обновляет последние инструменты и технологии ИИ, чтобы помочь пользователям легко использовать высококачественные инструменты ИИ и повысить креативную эффективность.');
        if (keywords) keywords.setAttribute('content',
          'Навигация по ИИ, 123Plat, настраиваемая платформа навигации, агрегация крупных моделей, GPT4, китайские модели, многоязычные модели, генерация текста');
        console.log('[元数据更新] 已设置为ru');
      }else if(lang === 'sw') {
        document.title = '123Plat - Jukwaa la Uendeshaji wa Zana za AI zinazoweza Badilishwa | Jukwaa la Ujumuishaji wa Mifano Mikubwa';
        const desc = document.querySelector('meta[name="description"]');
        const keywords = document.querySelector('meta[name="keywords"]');
        if (desc) desc.setAttribute('content',
          '123Plat (123plat.cloud) ni tovuti rahisi ya uendeshaji wa zana za AI inayounga mkono mipangilio inayoweza kubadilishwa. Inajumuisha mifano mikubwa ya Wachina (kama vile Wenxin, ERNIE3.0, GLM - 3 - 5XXL, nk.), Inayounga mkono uainishaji wa zana kwa mambo mengi yanayotokea, na inasasisha zana na teknolojia mpya zaidi za AI ili kusaidia watumiaji kutumia zana za AI za hali ya juu kwa urahisi na kuongeza ufanisi wa ubunifu.');
        if (keywords) keywords.setAttribute('content',
          'Uendeshaji wa AI, 123Plat, jukwaa la uendeshaji linaloweza kubadilishwa, ujumuishaji wa mifano mikubwa, GPT4, mifano ya Wachina, mifano ya lugha nyingi, utengenezaji wa maandishi');
        console.log('[元数据更新] 已设置为');
      }else if(lang === 'ta') {
        document.title = '123Plat - தனிப்பயன் AI கருவி வழிசெலுத்தல் தளம் | பெரிய மாதிரி தொகுப்பு தளம்';
        const desc = document.querySelector('meta[name="description"]');
        const keywords = document.querySelector('meta[name="keywords"]');
        if (desc) desc.setAttribute('content',
          '123Plat (123plat.cloud) என்பது தனிப்பயன் வடிவமைப்புகளை ஆதரிக்கும் எளிமையான AI கருவி வழிசெலுத்தல் இணையதளமாகும். இது சீன பெரிய மாதிரிகளை (எனவே Wenxin, ERNIE3.0, GLM - 3 - 5XXL, போன்றவை) ஒன்றிணைக்கிறது, பல - சூழ்நிலை கருவி வகைப்பாட்டை ஆதரிக்கிறது மற்றும் சமீபத்திய AI கருவிகள் மற்றும் தொழில்நுட்பங்களை புதுப்பிக்கிறது, இதனால் பயனர்கள் உயர் தரமான AI கருவிகளைப் பயன்படுத்துவதற்கு எளிதாக உதவி மற்றும் படைப்பு திறனை மேம்படுத்தும்.');
        if (keywords) keywords.setAttribute('content',
          'AI வழிசெலுத்தல், 123Plat, தனிப்பயன் வழிசெலுத்தல் தளம், பெரிய மாதிரி தொகுப்பு, GPT4, சீன மாதிரிகள், பல மொழி மாதிரிகள், உரை உருவாக்கம்');
        console.log('[元数据更新] 已设置为ta');
      }else if(lang === 'te') {
        document.title = '123Plat - కస్టమైజ్ చేయగల AI టూల్ నेवిగేషన్ ప్లాట్‌ఫారమ్ | పెద్ద మోడల్ అగ్రిగేషన్ ప్లాట్‌ఫారమ్';
        const desc = document.querySelector('meta[name="description"]');
        const keywords = document.querySelector('meta[name="keywords"]');
        if (desc) desc.setAttribute('content',
          '123Plat (123plat.cloud) అనేది కస్టమ్ లేఅవుట్లను మద్దతు ఇచ్చే సాధారణ AI టూల్ నेवిగేషన్ వెబ్సైట్. ఇది చైనా పెద్ద మోడల్స్ (ఉదా: Wenxin, ERNIE3.0, GLM - 3 - 5XXL మొదలైనవి) ను ఏకీకృతం చేస్తుంది, మల్టీ - సినారియో టూల్ వర్గీకరణను మద్దతు ఇచ్చి మరియు తాజా AI టూల్స్ మరియు సాంకేతికతలను నవీకరిస్తుంది కాబట్టి వినియోగదారులు అధిక - నాణ్యత AI టూల్స్ ను సులభంగా ఉపయోగించటానికి సహాయపడుతుంది మరియు సృజనాత్మక సామర్థ్యాన్ని మెరుగుపరుస్తుంది.');
        if (keywords) keywords.setAttribute('content',
          'AI నेवిగేషన్, 123Plat, కస్టమ్ నेवిగేషన్ ప్లాట్‌ఫారమ్, పెద్ద మోడల్ అగ్రిగేషన్, GPT4, చైనా మోడల్స్, బహుభాషా మోడల్స్, టెక్స్ట్ జనరేషన్');
        console.log('[元数据更新] 已设置为te');
      }else if(lang === 'tr') {
        document.title = '123Plat - Özelleştirilebilir AI Araç Navigasyon Platformu | Büyük Model Toplama Platformu';
        const desc = document.querySelector('meta[name="description"]');
        const keywords = document.querySelector('meta[name="keywords"]');
        if (desc) desc.setAttribute('content',
          '123Plat (123plat.cloud), özel düzenlemeleri destekleyen basit bir AI araç navigasyon web sitesidir. Çinli büyük modelleri (Wenxin, ERNIE3.0, GLM - 3 - 5XXL vb.) Toplar, çok senaryolu araç sınıflandırmasını destekler ve en son AI araçlarını ve teknolojilerini günceller, böylece kullanıcıların yüksek kaliteli AI araçlarını kolayca kullanmalarına yardımcı olur ve yaratıcı etkinliği artırır.');
        if (keywords) keywords.setAttribute('content',
          'AI navigasyonu, 123Plat, özel navigasyon platformu, büyük model toplama, GPT4, Çinli modeller, çok dilli modeller, metin üretimi');
        console.log('[元数据更新] 已设置为tr');
      }else if(lang === 'ur') {
        document.title = '123Plat - قابل سفارشی سازی AI ٹول نیویگیشن پلیٹ فارم | بڑے ماڈل جمع کرنے والا پلیٹ فارم';
        const desc = document.querySelector('meta[name="description"]');
        const keywords = document.querySelector('meta[name="keywords"]');
        if (desc) desc.setAttribute('content',
          '123Plat (123plat.cloud) ایک آسان AI ٹول نیویگیشن ویب سائٹ ہے جو حسب ضرورت کے لئے ترتیبات کو سہارا دیتا ہے۔ یہ چینی بڑے ماڈلز (جیسے Wenxin, ERNIE3.0, GLM - 3 - 5XXL وغیرہ) کو اکٹھا کرتا ہے، کئی منظرناموں کے ٹولز کی درجہ بندی کو سہارا دیتا ہے اور تازہ ترین AI ٹولز اور ٹیکنالوجیز کو اپ ڈیٹ کرتا ہے تاکہ صارفین کو آسانی سے اعلیٰ معیار کے AI ٹولز کا استعمال کرنے میں مدد ملے اور تخلیقی کارکردگی میں بہتری آئے۔');
        if (keywords) keywords.setAttribute('content',
          'AI نیویگیشن، 123Plat، قابل سفارشی سازی نیویگیشن پلیٹ فارم، بڑے ماڈل کا جمع، GPT4، چینی ماڈلز، کثیر زبانی ماڈلز، متن کی تخلیق');
        console.log('[元数据更新] 已设置为ur');
      }else if(lang === 'vi') {
        document.title = '123Plat - Nền tảng điều hướng công cụ AI tùy chỉnh | Nền tảng tổng hợp mô hình lớn';
        const desc = document.querySelector('meta[name="description"]');
        const keywords = document.querySelector('meta[name="keywords"]');
        if (desc) desc.setAttribute('content',
          '123Plat (123plat.cloud) là một trang web điều hướng công cụ AI đơn giản hỗ trợ bố cục tùy chỉnh. Nó tổng hợp các mô hình lớn của Trung Quốc (như Wenxin, ERNIE3.0, GLM - 3 - 5XXL, v.v.), hỗ trợ phân loại công cụ cho nhiều tình huống và cập nhật các công cụ và công nghệ AI mới nhất để giúp người dùng dễ dàng sử dụng các công cụ AI chất lượng cao và cải thiện hiệu quả sáng tạo.');
        if (keywords) keywords.setAttribute('content',
          'Điều hướng AI, 123Plat, nền tảng điều hướng tùy chỉnh, tổng hợp mô hình lớn, GPT4, mô hình Trung Quốc, mô hình đa ngôn ngữ, tạo văn bản');
        console.log('[元数据更新] 已设置为vi');
      }else{
        document.title = '123Plat - Custom AI Tool Navigation Platform | Large Model Aggregation Platform';
        const desc = document.querySelector('meta[name="description"]');
        const keywords = document.querySelector('meta[name="keywords"]');
        if (desc) desc.setAttribute('content',
          '123Plat (123plat.cloud) is a simple AI tool navigation website that supports custom layouts. It aggregates Chinese large models (such as Wenxin, ERNIE3.0, GLM - 3 - 5XXL, etc.), supports multi - scenario tool classification, and updates the latest AI tools and technologies to help users easily use high - quality AI tools and improve creative efficiency.');
        if (keywords) keywords.setAttribute('content',
          'AI navigation, 123Plat, custom navigation platform, large model aggregation, GPT4, Chinese models, multilingual models, text generation');
        console.log('[元数据更新] 已设置为');
      }






    } catch (e) {
      console.error('[元数据更新] 错误:', e);
    }
  };

  if (document.readyState === 'complete') {
    updateMeta();
  } else {
    window.addEventListener('load', updateMeta);
  }
}

/**
 * 公共路由
 */
export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login')
  },
  {
    path: '/',
    component: () => import('@/views/client/index'),
    hidden: true
  },
  {
    path: '/search/:searchContent',
    component: () => import('@/views/client/search'),
    hidden: true,
    meta: { title: 'Search' }
  },
  {
    path: '/about',
    component: () => import('@/views/client/about'),
    hidden: true,
    meta: { title: 'About' }
  },
  {
    path: '/site/:id',
    component: () => import('@/views/client/detail/SiteDetail'),
    hidden: true,
    meta: { title: 'Site Detail' }
  },
  {
    path: '/index',
    component: Layout,
    redirect: '/index',
    children: [
      {
        path: '',
        component: () => import('@/views/index'),
        name: 'Index',
        meta: { title: '首页', icon: 'dashboard', affix: true }
      }
    ]
  },
  {
    path: '/user',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'profile',
        component: () => import('@/views/system/user/profile'),
        name: 'Profile',
        meta: { title: '个人中心', icon: 'user' }
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    component: () => import('@/views/error/404'),
    hidden: true
  },
  {
    path: '/403',
    component: () => import('@/views/error/403'),
    hidden: true
  }
]

/**
 * 动态路由，基于用户权限动态去加载
 */
export const dynamicRoutes = [
  {
    path: '/system/role-auth',
    component: Layout,
    hidden: true,
    permissions: ['system:role:authUser'],
    children: [
      {
        path: 'user/:id',
        component: () => import('@/views/system/role/authUser'),
        name: 'AuthUser',
        meta: { title: '分配用户角色', activeMenu: '/system/role' }
      }
    ]
  },
  {
    path: '/system/api/data/',
    component: Layout,
    hidden: true,
    permissions: ['system:api:page'],
    children: [
      {
        path: ':id',
        component: () => import('@/views/system/api'),
        name: 'APIData',
        meta: { title: 'API 接口数据', activeMenu: '/system/api' }
      }
    ]
  },
  {
    path: '/system/dictionary/data',
    component: Layout,
    hidden: true,
    permissions: ['system:dictionary:data:page'],
    children: [
      {
        path: ':id',
        component: () => import('@/views/system/dictionary/data'),
        name: 'DictionaryData',
        meta: { title: '字典数据', activeMenu: '/system/dictionary' }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: constantRoutes
})

// 全局前置守卫
router.beforeEach((to, from, next) => {
  console.log('[路由守卫] 触发路径:', to.path, '语言参数:', to.query.lang)
  setPageMeta(to)
  next()
})

export default router
